<template>
<div>
    <h1 class="subtitle">Productos</h1>
    <div class="nj-cols">
        <div class="nj-card">
            <div class="nj-grid">
                <InputText label="Producto" v-model="producto.prv_nombre" @enter="buscar()"></InputText>
            </div>
            <br>
            <div class="nj-flex">
                <Button icon="find" label="Buscar" @click="buscar()"></Button>
                <Button icon="save" color="green" label="Nuevo" @click="popup({ componente: 'registrar', activar: true })"></Button>
            </div>
            <br>
            <b-table :data="productos" @page-change="changePage($event)" :total="producto.page.total" :per-page="producto.page.size" :current-page="producto.page.number" pagination-position="bottom"
                :pagination-rounded="true" :paginated="true" :backend-pagination="true">
                <template slot-scope="props">
                    <b-table-column label="ID" header-class="is-info">{{ props.row.prv_id }}</b-table-column>
                    <b-table-column label="Categoria" header-class="is-info">{{ props.row.cat_nombre }}</b-table-column>
                    <b-table-column label="Tipo" header-class="is-info">{{ props.row.tip_nombre }}</b-table-column>
                    <b-table-column label="Nombre" header-class="is-info">{{ props.row.prv_nombre }}</b-table-column>
                    <b-table-column label="Marca" header-class="is-info">{{ props.row.mar_nombre }}</b-table-column>
                    <b-table-column label="Estado" header-class="is-info">
                        <b-field>
                            <b-tag :class="setTag(props.row.prv_estado)">{{ props.row.prv_estado == 0 ? 'Deshabilitado'
                                : 'Habilitado' }}</b-tag>
                        </b-field>
                    </b-table-column>
                    <b-table-column label="Opciones" header-class="is-info">
                        <div class="nj-flx">
                            <Button title="Modificar" icon="edit" @click="popup({ componente: 'modificar', activar: true, prv_id: props.row.prv_id })"></Button>
                            <Button title="Duplicar" icon="copy" @click="popup({ componente: 'duplicar', activar: true, prv_id: props.row.prv_id })"></Button>
                            <Button title="Deshabilitar" icon="cancel" @click="deshabilitarProducto(props.row.prv_id)"></Button>
                        </div>
                    </b-table-column>
                </template>
            </b-table>
        </div>
    </div>
    <ProductoNew v-if="activarRegistrar" @close="popup($event)"></ProductoNew>
    <ProductoEdit v-if="activarModificar" :prv_id="prv_id" @close="popup($event)"></ProductoEdit>
    <DuplicarProducto v-if="activarDuplicar" :prv_id="prv_id" @close="popup($event)"></DuplicarProducto>
</div>
</template>

<script>
import { mapActions } from "vuex"
import { Opciones, productoEstado } from "../../constants"
import { ProductoService, ResponseStatus } from "../../rest"
import { Data } from "../../util"
import Acceso from "../../util/acceso"
import Toast from "../../util/toast"
import { Button, Buttons, InputSearch, InputSelect, InputText, Search } from "../components"
import DuplicarProducto from "./DuplicarProducto.vue"
import ProductoEdit from "./ProductoEdit.vue"
import ProductoNew from "./ProductoNew.vue"

export default {
    name: "ProductoList",
    components: {
        ProductoNew,
        ProductoEdit,
        DuplicarProducto,
        Buttons,
        InputText,
        InputSearch,
        Search,
        Button,
        InputSelect,
    },
    data() {
        return {
            categorias: [],
            tipos_producto: [],
            marcas: [],
            unidades_medida: [],
            productos: [],
            prv_id: null,
            producto: {
                cat_id: null,
                tip_id: null,
                mar_id: null,
                prv_nombre: null,
                page: {
                    number: 1,
                    size: 10,
                    total: 0
                },
            },
            cat_nombre_text: "",
            tip_nombre_text: "",
            mar_nombre_text: "",
            activarRegistrar: false,
            activarModificar: false,
            activarDuplicar: false,
        }
    },
    computed: {
        activarOpcionRegistrar() {
            return Acceso.activarOpcion(Opciones.REGISTRAR_PRODUCTO.opc_id)
        },
    },
    methods: {
        ...mapActions("product", [
            "_setPrvID",
            "_removePrvID",
        ]),
        getCategorias(text) {
            if (text != null) {
                return this.categorias.filter(item => item.descripcion.toLowerCase().includes(text.toLowerCase()))
            }
            else {
                return this.categorias
            }
        },
        setCategoria(item) {
            return item.descripcion
        },
        changePage(number) {
            this.producto.page.number = number
            this.buscar()
        },
        setTag(id) {
            return productoEstado(id)
        },
        buscar() {
            const request = {
                producto: this.producto
            }
            ProductoService
                .buscar(request)
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.producto.page = response.data
                        this.productos = this.producto.page.list
                    }
                    else {
                        Toast.warn(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                })
        },
        buscarTiposProducto(cat_id) {
            ProductoService.getTiposProductoxCategoria({
                categoria: {
                    cat_id
                }
            }).then(
                response => {
                    this.tipos_producto = response.data
                },
                error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                }
            )
        },
        popup({
            componente,
            activar,
            renderizar = false,
            prv_id = null
        }) {
            switch (componente) {
                case 'registrar':
                    this.activarRegistrar = activar
                    break
                case 'modificar':
                    this.prv_id = prv_id
                    this.activarModificar = activar
                    break
                case 'duplicar':
                    this.prv_id = prv_id
                    this.activarDuplicar = activar
                    break
            }
            if (renderizar) {
                this.buscar()
            }
        },
        deshabilitarProducto(prv_id) {
            const request = {
                producto: prv_id
            }
            ProductoService.deshabilitar(request).then(response => {
                if (ResponseStatus.isSuccess(response)) {
                    Toast.success(response.message)
                    this.buscar()
                }
                else {
                    Toast.warn(response.message)
                }
            }).catch(error => {
                Toast.error(error)

            })
        },
    },
    mounted() {
        this.unidades_medida = Data.get(Data.listNames.categorias)
        this.marcas = Data.get(Data.listNames.categorias)
        this.categorias = Data.get(Data.listNames.categorias)
        this.buscar()
    }
}
</script>

<style scoped></style>